import React from 'react';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import XBadge from '../lib/XBadge';
import { getRandomElement } from '../common/Helpers';
import flareLogo from '../../assets/images/icons/flare-logo.png';

const adVariations = [
  {
    label: <>Get involved &rarr;</>,
    title: <>Flare is building the DeFi ecosystem for XRP, with USD₮0 on Flare as the essential capital base.</>,
    href: "https://api.xrpscan.com/api/v1/campaign/flaretext",
  },
];
const adVariation = getRandomElement(adVariations);

const TextAd = () => {
  return (
    <div>
      <Card className="shadow-sm" border="info">
        <Card.Body>
          <XBadge variant="light"><small>Sponsored:</small></XBadge>
          <Image alt="Flare F logo" src={flareLogo} height="18" className="ml-1" />
          <span className="ml-1">{adVariation.title}</span>
          <span className="ml-2"><a href={adVariation.href} target="_blank" rel="noopener noreferrer">{adVariation.label}</a></span>
        </Card.Body>
      </Card>
    </div>
  );
}

export default TextAd;
